<template>
    <div class="xc-page xc-page-sandwich">
        <div class="xc-page-main">
            <div class="xc-breadcrumb">
                <router-link :to="$config.adminPath + '/device'">终端管理</router-link>
                <a>APK管理</a>
            </div>

            <!-- 铺满 -->
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <div class="xc-form-inline">
                            <xc-form-item label="版本名称：" labelWidth="0">
                                <input type="text" class="xc-input" placeholder="请输入MAC地址" v-model="mix_query.versionName">
                            </xc-form-item>
                            <xc-form-item label="apk名称：" labelWidth="0">
                                <input type="text" class="xc-input" placeholder="请输入" v-model="mix_query.upgradeName">
                            </xc-form-item>
                            <button type="submit" class="xc-btn xc-btn-primary" @click.prevent="mix_search" @click="modalName = 'upgradeDetail'">查询</button>
                        </div>
                        <div class="xc-form-inline">
                            <div class="xc-btn-group">
                                <button type="reset" class="xc-btn xc-btn-default" @click="openAdd">添加</button>
                                <button type="reset" class="xc-btn xc-btn-default" @click.prevent="goUpgrade">手动升级</button>
                                <!-- <a class="xc-btn xc-btn-default" @click="modalName = 'moveGroup'">移动分组</a> -->
                            </div>
                        </div>
                        <table class="xc-table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>apk名称</th>
                                    <th>版本名称</th>
                                    <th>大小</th>
                                    <!-- <th>是否强制升级</th> -->
                                    <th>添加时间</th>
                                    <th>是否定时升级/升级时间</th>
                                    <th>版本说明</th>
                                    <th>升级文件</th>
                                    <th>操作</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="list && list.length">
                                    <tr v-for="(item,key) in list" :key="key">
                                    <!-- item：{{item}} -->
                                        <td style="width: 45px;">
                                            <input type="checkbox" class="xc-checkbox" v-model="item.mix_checkbox">
                                        </td>
                                        <td>
                                            {{item.upgradeName}}
                                        </td>
                                        <td>
                                            {{item.versionName}}
                                        </td>
                                        <td>
                                            {{item.size}}
                                        </td>
                                        <!-- <td>
                                            {{item.active?'是':'否'}}
                                        </td> -->
                                        <td>
                                            {{item.addTime| moment}}
                                        </td>
                                        <td>
                                            {{item.isTiming == 1?'是':'否'}}
                                            <span v-if="item.timingTime ">/{{item.timingTime | moment}}</span>
                                        </td>
                                        <td>
                                            {{item.description}}
                                        </td>
                                        <td class="xc-link">
                                            <a href @click.prevent="downloadApk(item)">下载</a>
                                        </td>
                                        <td>
                                            <xc-btn-select title="管理">
                                                <xc-btn-select-item title="编辑" @click.native="action('edit',item)" />
                                                <xc-btn-select-item title="删除" @click.native="action('delete',item)" />
                                                <xc-btn-select-item title="升级详情" @click.native="action('upgradeDetail',item)" />
                                            </xc-btn-select>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="14" class="xc-s-tac">暂无数据</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- 固低栏 -->
        <div class="xc-page-footer">
            <!-- 分页 -->
            <xc-pagination @change="mix_pageChange" :page="mix_page" :total="mix_total" :size="mix_pageSize" />
        </div>

        <!--新增/编辑-->
        <div class="xc-modal " v-if="modalName=='add' || modalName=='edit'">
            <div class="xc-modal-mask" @click="modalName=null"></div>
            <div class="xc-modal-wrap xc-anim-scaleIn">
                <div class="xc-modal-content">
                    <div class="xc-modal-header">
                        <div class="xc-modal-title">
                            {{modalName == 'add'?'APK版本添加':'APK编辑'}}
                        </div>
                        <div class="xc-modal-close" @click="modalName=null"></div>
                    </div>
                    <div class="xc-modal-body">
                        <form class="xc-form xc-form-add" name="add">
                            <div class="xc-form-inline">
                                <xc-form-item label="升级文件" required :error="errors.first('title')">
                                <!-- <div v-if="detail.files">
                                    {{detail.files}}
                                </div> -->
                                    <xc-upload :fileList.sync="detail.files" :multiple="false" type="0" :url="uploadUrl" dataName='url' accept=".apk" uploadMode="backend" />
                                </xc-form-item>
                            </div>
                            <div class="xc-form-inline">
                                <xc-form-item label="APK名称" required :error="errors.first('upgradeName')">
                                    <input v-validate="'required'" data-vv-as="标题" name="upgradeName" type="text" maxlength="255" class="xc-input" placeholder="请输入" v-model="detail.upgradeName">
                                </xc-form-item>
                            </div>
                            <div class="xc-form-inline">
                                <xc-form-item label="版本名称" required>
                                    <input type="text" class="xc-input xc-input-disabled" v-model="detail.versionName" disabled placeholder="上传后自动获取">
                                </xc-form-item>
                                <xc-form-item label="文件大小">
                                    <input type="text" class="xc-input xc-input-disabled" v-model="detail.size" disabled placeholder="上传后自动获取">
                                </xc-form-item>
                            </div>
                            <div class="xc-form-inline">
                                <!-- <xc-form-item label="是否强制升级">
                                    <select class="xc-select" v-model="detail.active">
                                        <option value="0">否</option>
                                        <option value="1">是</option>
                                    </select>
                                </xc-form-item> -->
                                <xc-form-item label="是否定时升级时间">
                                    <select class="xc-select" v-model="detail.isTiming">
                                        <option value="0">否</option>
                                        <option value="1">是</option>
                                    </select>
                                </xc-form-item>
                            </div>
                            <div class="xc-form-inline" v-if="detail.isTiming == 1">
                                <xc-form-item label="升级时间">
                                    <flat-pickr v-model="detail.timingTime" class="xc-input" :config="{enableTime: true,enableSeconds: true,time_24hr: true}" placeholder="请选择时间"></flat-pickr>
                                </xc-form-item>
                            </div>
                            <xc-form-item label="版本说明:">
                                <textarea class="xc-textarea" v-model="detail.description" maxlength="30" placeholder="最多30个字"></textarea>
                            </xc-form-item>
                        </form>
                    </div>
                    <div class="xc-modal-footer xc-flex-center">
                        <div class="xc-btn-group">
                            <button type="button" class="xc-btn xc-btn-default" @click="modalName=null">取消</button>
                            <button type="button" class="xc-btn xc-btn-primary" @click="saveApk">保存</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import myLayerImport from '@/libs/myLayer';
myLayerImport();

// vee-validate验证
import '@/libs/vee-validate'
import listMixin from "../xc-ui/mixins/list";
import '@/libs/flatpickr';
import deviceApi from '../api/device';
import '../utils/date-format';
import moment from 'moment'

export default {
    name: 'deviceApk',
    mixins: [listMixin],
    data() {
        return {
            // 弹出窗
            modalName: null,

            // 列表key
            mix_listKey: "list",

            // 列表唯一字段
            mix_listId: "deviceUpgradeId",

            // 列表数据
            list: [],

            // 默认查询参数
            mix_query: {

            },

            // 弹窗详情
            defaultDetail: {
                isTiming: 0,
                // active: 0,
            },
            detail: {},

            // apk上传接口
            uploadUrl: '/DeviceUpgrade/uploadApk'
        };
    },

    created() {

    },

    methods: {
        downloadApk(item) {
            const rawUrl = (item && item.url ? String(item.url) : '').trim();
            if (!rawUrl) {
                this.$message.error('下载地址为空');
                return;
            }
            let finalUrl = rawUrl;
            try {
                const decodedUrl = decodeURIComponent(rawUrl);
                if (/^https?:\/\//i.test(decodedUrl)) {
                    finalUrl = decodedUrl;
                }
            } catch (e) {
                // 非合法编码字符串时保持原值
            }
            window.open(finalUrl, '_blank');
        },
        openAdd() {
            this.modalName = 'add';
            this.detail = {
                ...this.defaultDetail,
            }
        },
        goUpgrade() {
            const { mix_checkedList } = this;
            if(mix_checkedList && mix_checkedList.length > 1) return this.$message.error('apk只能选择一个');
            if(!mix_checkedList || mix_checkedList.length == 0) return this.$message.error('请选择需要升级的apk');
            const deviceUpgradeId = mix_checkedList[0].deviceUpgradeId;
            this.$router.push(`${this.$config.adminPath}/device/apk/${deviceUpgradeId}/upgrade`);
        },

        saveApk() {
            this.$validator.validateAll().then(validate => {
                if (validate) {
                    if (!this.detail.url) return this.$message.error('请先上传apk');
                    if (this.detail.isTiming != 1) delete this.detail.timingTime;
                    if (!this.detail.description) delete this.detail.description;

                    const saveData = {
                        ...this.detail,
                    }

                    if (this.modalName == 'add') {
                        deviceApi.addApk(saveData).then(v => {
                            this.modalName = null;
                            this.mix_page = 1;
                            this.initData();
                            this.$message.success('上传成功');
                        })
                    } else {
                        deviceApi.editApk(saveData).then(v => {
                            this.$message.success('保存成功');
                            this.modalName = null;
                            this.initData();
                        })
                    }

                }
            })
        },
        // 初始化数据
        initData() {
            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query,
            }

            deviceApi.getApkList(search).then(ret => {
                this.list = this.mix_format(ret.data.list);
                this.mix_total = ret.data.total;
                this.mix_page = ret.data.pageNum;
                this.mix_pageSize = ret.data.pageSize;
            })
        },
        action: function (action, item) {
            if (action == 'edit') {
                this.modalName = 'edit';

                // item.timingTime = moment(item.timingTime).format('YYYY-MM-DD HH:mm:ss')
                this.detail = {
                    ...item,
                    timingTime: moment(item.timingTime).format('YYYY-MM-DD HH:mm:ss')
                }

            } else if (action == 'delete') {
                this.$xc.confirm({
                    title: '删除',
                    msg: '确认删除该apk版本？',
                }).then(v => {
                    deviceApi.deleteApk(item.deviceUpgradeId).then(v => {
                        // 后台删除成功后调用
                        this.mix_delete(item, '删除成功');
                    })

                })
            } else if (action == 'upgradeDetail') {

                layer.open({
                    type: 2,
                    title: false,
                    closeBtn: 0,
                    area: ['976px', '550px'],
                    shadeClose: true,
                    content: `${this.$config.adminPath}/device/apk/${item.deviceUpgradeId}/upgrade-detail`,
                });
            }
        }
    },
    watch: {
        'detail.files'(v) {
            if (v && v.length && v[0].url) {
                this.detail.versionCode = v[0].versionCode;
                this.detail.versionName = v[0].versionName;
                this.detail.packageName = v[0].packageName;
                if (!this.detail.upgradeName) this.detail.upgradeName = v[0].upgradeName;
                    this.detail.size = v[0].size;
                    this.detail.url = v[0].url;
                    this.detail.md5 = v[0].md5;
            }
        }
    }
};
</script>

<style lang="scss" scoped>

.xc-device-group-head {
    margin-bottom: 10px;
}

.xc-modal-footer-style {
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
}

.xc-form-add .xc-form-item-label {
    width: 110px !important;
    white-space: nowrap;
}

</style>

    white-space: nowrap;
}

</style>
